exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#quality-assessment {\n  overflow-y: scroll;\n  height: 100%;\n  padding: 20px;\n}\n\n#qa-chats {\n  height: 100vh;\n}", ""]);

